/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/mfa/user-device-tokens`,
    // @ts-ignore for sm-axios
    urlTemplate: '/mfa/user-device-tokens',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * Creates a new user device token. Each browser or device should have a unique user device token to identify it for subsequent requests. The token is a JWT of the provided values plus iat in milliseconds.
 * 
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  body: {
    token: string
  }
}

export interface Response {
  /**
   * a jwt represents a user device token
   */
  userDeviceToken: string
}

